export class ChangePasswordRequest {
  old_password: string;
  new_password: string;
  confirmation: string;

  constructor(oldPassword: string, newPassword: string, confirmation: string) {
    this.old_password = oldPassword;
    this.new_password = newPassword;
    this.confirmation = confirmation;
  }
}
